export default __webpack_public_path__ + "static/media/INCAPACITATION.9efc0236.pdf";